import Card from "@components/Card";
import { useAuthContext } from "@contexts/auth";
import { cardTexts } from "@utils/cardTexts";
import { formatDateDMY, formatDateMY } from "@utils/formatDate";
import { formatNumberToCurrency, formatNumberToLocale } from "@utils/formatNumber";
import { indexerCardName, isInccIndexed } from "@utils/indexerLabel";

const { useProjectContext } = require("@contexts/projects");

const BasicInfo = () => {
  const { activeProject } = useProjectContext();

  const { user: { configurations: { mainCards } } } = useAuthContext();

  // INCC é número-índice (encadeado, ago/1994 = 100): o card mostra o número sem "R$", o mês
  // da data-base e a variação acumulada desde ela — é a variação que corrige o orçamento.
  const inccCard = () => {
    const current = activeProject?.indexer?.value
    const original = activeProject?.originalIndexer?.value
    const variation = Number.isFinite(current) && Number.isFinite(original) && original !== 0
      ? `${formatNumberToLocale((current / original - 1) * 100)}%`
      : '—'
    return <Card label={indexerCardName(activeProject)}
      content={`${formatNumberToLocale(current)} - ${formatDateMY(activeProject?.indexer?.date_used_in) ?? '—'}`}
      subcontent={`Data-base: ${formatDateMY(activeProject?.originalIndexer?.date_used_in) ?? '—'} · Variação: ${variation}`}
      tooltip={cardTexts.INCC}
    />
  }

  const checkCard = (i) => {
    switch (i) {
      case 'startDate':
        return <Card label='Data de Início' content={formatDateDMY(activeProject?.start_date) ?? "-"} tooltip={cardTexts.BUILDING_START} />
      case 'endDate':
        return <Card label='Data de Término' content={activeProject?.prediction_of_the_end ? formatDateDMY(activeProject?.prediction_of_the_end) : formatDateDMY(activeProject?.end_date)} subcontent={`Previsão original: ${activeProject?.end_date ? formatDateDMY(activeProject?.end_date) : '-'}`} tooltip={cardTexts.BUILDING_PREVISION} />
      case 'indexer':
        if (isInccIndexed(activeProject)) return inccCard()
        return <Card label={`${activeProject.indexer?.description} - ${activeProject.indexer?.type} (R$)`}
          content={`${formatNumberToCurrency(activeProject?.indexer?.value, false)} - ${formatDateMY(activeProject?.indexer?.date_used_in)}`}
          subcontent={`Valor original: ${formatNumberToCurrency(activeProject?.originalIndexer?.value, false)} - ${formatDateMY(activeProject?.originalIndexer?.date_used_in)}`}
          tooltip={cardTexts.CUB}
        />
      case 'area':
        return <Card label='Área construida (M²)' content={formatNumberToLocale(activeProject.area)} tooltip={cardTexts.AREA} />

      default:
        break;
    }
  }

  return (
    <div className="grid gap-24 columns-2-tablet columns-4-laptop-l">
      {(mainCards ?? []).map(i => {
        return checkCard(i)
      })}
    </div>
  );
};

export default BasicInfo;
